/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Empty,
  Row,
  Col,
  Spin,
  Card,
} from 'antd';
import { checkToken } from 'api/utils';
import {
  getLiquidacionesConfiguraciones,
} from 'api/nominas/liquidaciones/liquidacionesConfiguraciones';
import LiquidacionesConfiguracionesAnexos from './LiquidacionesConfiguracionesAnexos';

export const documentosParaLiquidacionesPermission = {
  permissionModel: 'liquidacionconfiguracionanexo',
  catalogsModels: ['estadosglobales'],
  tabsModels: [],
};

const DocumentosParaLiquidaciones = ({ permission }) => {
  const [loading, setLoading] = useState(false);
  const [liquidacionConfiguracion, setLiquidacionConfiguracion] = useState();

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const _data = await getLiquidacionesConfiguraciones();
      if (mounted) {
        setLiquidacionConfiguracion(_data?.[0]);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          title="Documentos para Anexar"
          bordered={false}
        >
          {liquidacionConfiguracion ? (
            <LiquidacionesConfiguracionesAnexos
              permission={permission}
              liquidacionConfiguracion={liquidacionConfiguracion}
            />
          ) : (
            !loading && (
              <Row align="middle" style={{ height: '100%' }}>
                <Col span={24}>
                  <Empty
                    description={
                      <p>Necesitas crear una configuración de liquidaciones primero.</p>
                    }
                  />
                </Col>
              </Row>
            )
          )}
        </Card>
      </Spin>
    </Row>
  );
};

export default DocumentosParaLiquidaciones;
